import {ApiExecutor, MissingProductionAdminAuthenticationAdapter, PreviewAdminAuthenticationAdapter, type FrontendRuntime} from "@shifath/platform-admin-core";

export function createAppRuntime(): FrontendRuntime {
  const raw = String(import.meta.env.VITE_ADMIN_DATA_SOURCE ?? "");
  const dataSource = (raw || (import.meta.env.DEV ? "preview" : "")) as "preview" | "backend" | "";
  if (import.meta.env.PROD && dataSource !== "backend") {
    throw new Error("Production build requires VITE_ADMIN_DATA_SOURCE=backend; Preview fallback is forbidden.");
  }
  if (dataSource !== "preview" && dataSource !== "backend") {
    throw new Error("VITE_ADMIN_DATA_SOURCE must be preview or backend");
  }
  const adminApiBaseUrl = String(import.meta.env.VITE_PLATFORM_ADMIN_API_BASE_URL ?? "").replace(/\/$/, "");
  const auth = dataSource === "preview"
    ? new PreviewAdminAuthenticationAdapter()
    : new MissingProductionAdminAuthenticationAdapter();
  if (dataSource === "backend" && !adminApiBaseUrl) {
    throw new Error("Backend mode requires VITE_PLATFORM_ADMIN_API_BASE_URL");
  }
  return {
    dataSource,
    adminApiBaseUrl,
    auth,
    api: dataSource === "backend" ? new ApiExecutor(adminApiBaseUrl, auth) : undefined,
  };
}
